/**
 * 金额格式化
 * @param {*} number
 * @returns
 */
export function amount(number) {
  return isNaN(number) ? 0.00 : (Number(number) / 100).toFixed(2)
}

/**
 * *全局拦截器: 秒转日期
 * @param second
 * @returns {string}
 */
export function duration(second) {
  let duration
  const days = Math.floor(second / 86400)
  const hours = Math.floor((second % 86400) / 3600)
  const minutes = Math.floor(((second % 86400) % 3600) / 60)
  const seconds = Math.floor(((second % 86400) % 3600) % 60)
  if (days > 0) {
    if (seconds === 0 && minutes === 0 && hours === 0) {
      duration = days + '天'
    } else {
      duration = days + '天' + hours + '小时' + minutes + '分' + seconds + '秒'
    }
  } else if (hours > 0) {
    if (seconds === 0 && minutes === 0) {
      duration = hours + '小时'
    } else {
      duration = hours + '小时' + minutes + '分' + seconds + '秒'
    }
  } else if (minutes > 0) {
    if (seconds === 0) {
      duration = minutes + '分'
    } else {
      duration = minutes + '分' + seconds + '秒'
    }
  } else if (seconds > 0) {
    duration = seconds + '秒'
  }
  if (duration === undefined) {
    return '0'
  }
  return duration
}

/**
 * 屏蔽手机号后六位
 * @param phone
 * @returns {string}
 */
export function mobile(phone) {
  if (!phone) {
    return ''
  }
  if (phone.length === 11) {
    return phone.substring(0, 3) + '****' + phone.substring(7, 11)
  } else {
    return phone
  }
}

/**
 * 格式化邮箱
 * @param email
 * @returns {*}
 */
export function formatEmail(email) {
  const [localPart, domainPart] = email.split('@');
  const maskedLocalPart = localPart.replace(/.(?=.{1,5}$)/g, '*'); 
  return `${maskedLocalPart}@${domainPart}`;
}
